import { Vue, MsgBox } from '../../app.vues';
import { Utils } from '../../app.base';

import SebAuthServicerForSelect from './AuthServicerForSelect'
Vue.regist(SebAuthServicerForSelect);

export function openAuthServicerForSelectDlg(params, callback) {
    let multiSelect = params['multiSelect'];
    let filter = params || {};
    Vue.$showDialog({
        title: '授权服务商-选择',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        template: '<swb-auth-servicer-list-for-select :isMultiSelect="multiSelect" :filter="filter" ref="swb_auth_servicer_list_for_select"></swb-auth-servicer-list-for-select>',
        data: {
            multiSelect: multiSelect,
            filter: filter
        },
        okClicked: function () {
            let result = this.$refs.swb_auth_servicer_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/servicer/selectDlg.js
// module id = 60
// module chunks = 1